var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fb-main-body',[_vm._v("你无权访问该页面")])
}
var staticRenderFns = []

export { render, staticRenderFns }